import React from 'react';
import { Box, Button, Card, CardContent, Divider, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

import { formatDate } from './approvalWorkflowFormatters';

export default function ApprovalInboxCard({ inbox, canDecide, onDecision }) {
    return (
        <Card>
            <CardContent>
                <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" spacing={2}>
                    <Typography variant="h6">Inbox – zu genehmigen</Typography>
                    <Typography variant="body2" color="text.secondary">
                        {inbox.length === 0 ? 'Keine offenen Freigaben.' : `${inbox.length} Vorgänge warten auf Prüfung.`}
                    </Typography>
                </Stack>
                <Divider sx={{ my: 2 }} />
                <Box sx={{ overflowX: 'auto' }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Typ</TableCell>
                                <TableCell>Referenz</TableCell>
                                <TableCell>Erstellt von</TableCell>
                                <TableCell>Kommentar</TableCell>
                                <TableCell>Erstellt am</TableCell>
                                <TableCell align="right">Aktionen</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {inbox.map((item) => (
                                <TableRow key={item.id}>
                                    <TableCell>{item.type}</TableCell>
                                    <TableCell>{item.targetId}</TableCell>
                                    <TableCell>{item.creatorName || item.creatorId}</TableCell>
                                    <TableCell>{item.comment || '-'}</TableCell>
                                    <TableCell>{formatDate(item.createdAt)}</TableCell>
                                    <TableCell align="right">
                                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                                            <Button
                                                variant="contained"
                                                size="small"
                                                color="success"
                                                disabled={!canDecide}
                                                onClick={() => onDecision(item.id, {}, true)}
                                            >
                                                Freigeben
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                color="error"
                                                disabled={!canDecide}
                                                onClick={() => onDecision(item.id, {}, false)}
                                            >
                                                Ablehnen
                                            </Button>
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </CardContent>
        </Card>
    );
}
